import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const LeftSideWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(p) => p.theme.spacing(2)};
`;

export const SearchModeWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(2)};
  max-height: ${(p) => p.theme.spacing(3)};
`;

export const SearchModeText = styled(Typography)`
  font-weight: ${(p) => p.theme.typography.fontWeightBold};
`;

export const PoweredByText = styled(Typography)``;

export const DescriptionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const Description = styled(Typography)`
  display: inline;
  margin: ${(p) => p.theme.spacing(0, 1)};
  background: linear-gradient(90deg, #1851ef 63.34%, #9bb2f8 100%);

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* font-size: ${(p) => p.theme.spacing(3)}; */
  /* font-weight: 700; */
  text-align: start;
  width: 100%;

  ${(p) => p.theme.breakpoints.down('md')} {
  }

  @media (max-height: 800px) {
  }
`;

export const StatisticsCardWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(1.5)};
`;
